<template>
    <div class="step-indicator">
        <div class="step" :class="{'active': (currStep === 1), 'done': (currStep > 1)}">
            <div>
                <span v-if="currStep === 1" class="step__number">1</span>
                <CheckboxIcon v-else />
            </div>

            <span class="step__title">Step 1</span>
        </div>
        <svg class="step-line" width="117" height="3" viewBox="0 0 117 3" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <line y1="1.5" x2="117" y2="1.5" stroke="#4A42BD" stroke-dasharray="4 4"/>
        </svg>
        <div class="step" :class="{'active': (currStep === 2), 'done': (currStep > 2)}">
            <div>2</div>
            <span class="step__title">Step 2</span>
        </div>
    </div>
</template>

<script>
import CheckboxIcon from "./blocks/checkout/CheckboxIcon.vue";

export default {
    name: "StepIndicator",
    components: {CheckboxIcon},
    props: {
        stepsCount: 2,
        currStep: {
            type: Number,
            default: 1
        }
    }
}
</script>

<style scoped>

</style>
